/* WA redesign — progressive enhancement (reveal on scroll + sticky header state) */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Scroll reveal
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = [].slice.call(document.querySelectorAll('.wa-reveal'));
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }

    // Header scrolled state
    var header = document.querySelector('.header');
    if (header) {
      var onScroll = function () {
        if (window.scrollY > 12) header.classList.add('is-sticky');
        else header.classList.remove('is-sticky');
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Hero video: click to play. Keep the poster + spinner up until the YouTube
    // player has actually loaded, then reveal it — so there's no grey "loading"
    // flash and it appears to play cleanly from the start.
    var heroVideo = document.querySelector('.wa-hero__video');
    if (heroVideo) {
      heroVideo.addEventListener('click', function () {
        if (heroVideo.classList.contains('is-playing')) return;
        var f = heroVideo.querySelector('iframe');
        heroVideo.classList.add('is-playing');
        if (f && !f.getAttribute('src') && f.getAttribute('data-src')) {
          f.addEventListener('load', function () { heroVideo.classList.add('is-loaded'); });
          // safety net: reveal after a beat even if 'load' is slow to fire
          setTimeout(function () { heroVideo.classList.add('is-loaded'); }, 2500);
          f.setAttribute('src', f.getAttribute('data-src'));
        } else {
          heroVideo.classList.add('is-loaded');
        }
      });
    }

    // Hero ambient background video: desktop only, respect reduced-motion + data-saver
    var bgVideo = document.querySelector('.wa-hero__bg-video');
    if (bgVideo) {
      var reduceBg = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var conn = navigator.connection || {};
      var isDesktop = window.matchMedia('(min-width: 901px)').matches;
      if (isDesktop && !reduceBg && !conn.saveData) {
        var vsrc = bgVideo.getAttribute('data-src');
        if (vsrc) {
          bgVideo.src = vsrc;
          bgVideo.addEventListener('canplay', function () { bgVideo.classList.add('is-ready'); });
          var playPromise = bgVideo.play();
          if (playPromise && playPromise.catch) { playPromise.catch(function () {}); }
        }
      }
    }

    // Click-to-play videos (events, and any [data-wa-video] element): load the iframe on click
    // so multiple embeds never autoplay or weigh the page down.
    [].slice.call(document.querySelectorAll('[data-wa-video]')).forEach(function (v) {
      var play = function () {
        if (v.classList.contains('is-playing')) return;
        var f = v.querySelector('.wa-video__frame');
        if (f && f.getAttribute('data-src') && !f.getAttribute('src')) {
          f.setAttribute('src', f.getAttribute('data-src'));
        }
        v.classList.add('is-playing');
      };
      var btn = v.querySelector('.wa-video__play');
      (btn || v).addEventListener('click', play);
    });

    // Hero trust rating: keep the Google rating + review count in sync with the live
    // Google-reviews app (Trustify) the store already runs. Progressive enhancement — the
    // server-rendered values stay if the fetch/parse fails. Cached ~6h per browser.
    (function () {
      var box = document.querySelector('[data-wa-reviews]');
      if (!box || !window.fetch) return;
      var shop = box.getAttribute('data-wa-reviews-shop');
      if (!shop) return;
      var ratingEl = box.querySelector('.wa-hero__rating');
      var reviewsEl = box.querySelector('.wa-hero__reviews');
      var KEY = 'waReviews:' + shop, TTL = 6 * 3600 * 1000;
      function apply(d) {
        if (!d) return;
        if (d.rating && ratingEl) ratingEl.textContent = d.rating;
        if (d.count && reviewsEl) reviewsEl.textContent = d.count;
      }
      try {
        var cached = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (cached && (Date.now() - cached.t) < TTL) { apply(cached); return; }
      } catch (e) {}
      var url = 'https://api-greview.trustifyreview.com/views/reviews?Shop=' +
        encodeURIComponent(shop) + '&Layout=1&page=1&limit=1';
      fetch(url, { credentials: 'omit' }).then(function (r) { return r.text(); }).then(function (html) {
        var cm = html.match(/([\d,]+)\s*reviews?/i);
        var wm = html.match(/average-stars--positive[^>]*width:\s*([0-9.]+)%/i);
        var count = cm ? cm[1].replace(/,/g, '') : null;
        var rating = wm ? (parseFloat(wm[1]) / 20).toFixed(1) : null;
        if (!count && !rating) return;
        var data = { rating: rating, count: count, t: Date.now() };
        apply(data);
        try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
      }).catch(function () {});
    })();
  });
})();
